module.exports = "../images/northern-pike-fishing-ontario@2x.jpg?v=0deb740";